import React, { useState, useEffect } from "react";
import { DatePicker, Button, Tooltip, notification } from "antd";
import Table from "./table/JSLOverallReportTable";
import { HiOutlineInboxArrowDown } from "react-icons/hi2";
import JSLOverallFilter from "./JSLOverallFilter";
import { CSVLink } from "react-csv";
import { useReportsStore } from "../ReportsStore";
import { useSearchParams } from "react-router-dom";
import "../reports.scss";
import dayjs from "dayjs";
import dbstorage from "../../../lib/DBStorage";

import notificationFilter from "../../../components/NotificationFilter";
import { useComponentStore } from "../../../components/ComponentsStore";

const JslOverallReport = () => {
  const yesterday = dayjs().subtract(1, "day");

  const [tableData, setTableData] = useState([]);
  const [showLast24hrsReport, setShowLast24hrsReport] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const handleDatePicker = (date) => {
    setJslStatsSelectFilter(date);
  };
  const { setNotificationCount } = useComponentStore();
  const {
    jslStatsFirstRender,
    setJslStatsFirstRender,
    jslStatsSelectFilter,
    setJslStatsSelectFilter,
  } = useReportsStore();

  const headers = [
    { label: "SN", key: "sn" },
    { label: "Description", key: "sub_lable" },
    { label: "Data", key: "total" },
  ];

  const handleLast24hr = () => {
    setShowLast24hrsReport(!showLast24hrsReport);
  };

  const disableFutureDate = (current) => {
    return current && current.isAfter(yesterday);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      if (jslStatsFirstRender) {
        let selectFilter = searchParams.get("jslStatsSelectFilter");

        if (selectFilter !== undefined && selectFilter?.length > 0) {
          setJslStatsSelectFilter(dayjs(selectFilter));
        }
        setJslStatsFirstRender(false);
      }
      const jslData = await JSLOverallFilter.getJSLOverallReport(
        jslStatsSelectFilter
      );
      const { daily, overAll } = jslData;
      setTableData(showLast24hrsReport ? daily : overAll);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const updateQueryParams = () => {
    setSearchParams({
      jslStatsSelectFilter:
        jslStatsSelectFilter !== null
          ? dayjs(jslStatsSelectFilter).format("DD-MM-YYYY")
          : "",
    });
  };
  const [api, contextHolder] = notification.useNotification();
  const noDataNotification = () => {
    api.info({ title: "No Data Available !",
      placement: "bottomRight",
      style: { backgroundColor: "#ceddf5" },
      duration: 2,
    });
  };
  const handleDownloadClick = async () => {
    if (!tableData.length) {
      noDataNotification();
      return;
    } else {
      await download();
    }
  };
  const download = async () => {
    try {
      let userid;
      await dbstorage.get("user").then((user) => {
        userid = user._id;
      });

      await notificationFilter.createCsv(
        "jsl_report",
        userid,
        "",
        "",
        "",
        jslStatsSelectFilter
      );
      const count = await notificationFilter.getCount(userid);

      setNotificationCount(count.count);

      // return transformedCsvData;
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (!jslStatsFirstRender) {
      updateQueryParams();
    }
  }, [jslStatsSelectFilter]);
  useEffect(() => {
    fetchData();
  }, [showLast24hrsReport, jslStatsSelectFilter]);

  return (
    <>
      <div className="card-background">
        <div className="d-flex justify-content-between mb-3 align-items-center">
          <div className="d-flex align-items-center justify-content-between search-filter">
            <DatePicker
              value={jslStatsSelectFilter}
              onChange={handleDatePicker}
              disabledDate={disableFutureDate}
              allowClear={false}
              format="DD-MM-YYYY"
            />
            <Button className="custom-btn ms-3" onClick={handleLast24hr}>
              Last 24 hrs report
            </Button>
            <Button className="custom-btn ms-3" onClick={handleLast24hr}>
              overall report
            </Button>
            {/* <div className="card-heading ms-2">
              JSL Overall Report (
              {showLast24hrsReport
                ? "Last-24-Hours"
                : `${jslStatsSelectFilter.$d.getDate()}` +
                  "-" +
                  `${jslStatsSelectFilter.$d.getMonth() + 1}` +
                  "-" +
                  `${jslStatsSelectFilter.$d.getFullYear()}`}
              )
            </div> */}
          </div>
          <Button
            className="border-0 shadow-none me-4"
            icon={
              <Tooltip title="Download">
                <span>
                  <HiOutlineInboxArrowDown className="text-color-grey fs-4" />
                </span>
              </Tooltip>
            }
            type="text"
            onClick={handleDownloadClick}
          />
        </div>
        <Table tableData={tableData} loading={loading} />
      </div>
    </>
  );
};

export default JslOverallReport;
